<template>
  <div class="p-0 flex flex-col items-center justify-start min-h-[75vh]">
    <div class="container max-w-screen-lg mx-auto">
      <div>

        <!-- modal -->
        <ModalQuestions
          :open="questionModalOpen"
          :canClose="true"
          @submit="registerQuestion"
          @close="close"
        />

        <div class="bg-white rounded shadow-lg p-4 px-4 md:p-8 mb-6">
          <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
            <div class="text-left block mb-4">
              <p class="mb-2 font-medium text-lg text-gray-900">
                {{ props.descriptionTitle }}
              </p>
              <p class="text-gray-500">
                Campos com <span class="text-red-500">*</span> são obrigatórios
              </p>
            </div>

            <div class="lg:col-span-2 space-y-3 text-start" id="form-fields">
              <!-- Título -->
              <div class="lg:col-span-2 space-y-3 text-start">
                <div>
                  <label class="block mb-2 text-sm font-semibold text-gray-700"
                    >Título da Prova</label
                  >
                  <input
                    v-model="store.state.form.title"
                    name="title"
                    type="text"
                    class="w-full px-4 py-2 text-sm text-gray-800 placeholder-gray-400 bg-white border border-gray-300 rounded-xl shadow-sm focus:outline-none"
                    placeholder="AVALIAÇÃO DE CONHECIMENTO - NR X"
                    required
                  />
                  <span name="form.title" class="text-red-600 text-sm" />
                </div>
              </div>

              <!-- trein. -->
              <div class="md:col-span-2">
                <div class="md:col-span-2 mt-1.5">
                  <label
                    class="block mb-2 text-sm font-semibold text-gray-700"
                    for="event_id"
                  >
                    Selecione o treinamento
                  </label>
                  <div class="h-10 flex rounded items-center">
                    <SimpleSelect
                      class="px-1 py-2 text-center uppercase appearance-none outline-none text-gray-800 w-full bg-transparent"
                      :key="trainings"
                      :data="trainings"
                      :disable-keyboard="false"
                      :initialValue="store.state.form.event_id?.[0]"
                      @selected-data="
                        (val) => {
                          if(store.state.form.event_id == null)
                            store.state.form.event_id = val?.value
                          else
                            store.state.form.event_id?.[0]
                        }
                      "
                    />
                  </div>
                  <span
                    name="form.event_id"
                    class="text-red-600 text-sm"
                  />
                </div>
              </div>

              <!-- pont. min -->
              <div class="grid grid-cols-3 gap-4 mt-3">
                <div>
                  <label class="block mb-2 text-sm font-semibold text-gray-700"
                    >Pontuação mínima</label
                  >
                  <input
                    v-model.number="store.state.form.min_grade_required"
                    type="number"
                    name="min_grade_required"
                    min="1"
                    step="1"
                    class="w-full px-4 py-2 text-sm text-gray-800 placeholder-gray-400 bg-white border border-gray-300 rounded-xl shadow-sm focus:outline-none"
                  />
                  <span
                    name="form.min_grade_required"
                    class="text-red-600 text-sm"
                  />
                </div>

                <div>
                  <label class="block mb-2 text-sm font-semibold text-gray-700"
                    >Nota máxima</label
                  >
                  <input
                    v-model.number="store.state.form.max_grade"
                    type="number"
                    name="min_grade_required"
                    min="1"
                    step="1"
                    class="w-full px-4 py-2 text-sm text-gray-800 placeholder-gray-400 bg-white border border-gray-300 rounded-xl shadow-sm focus:outline-none"
                  />
                  <span
                    name="form.max_grade"
                    class="text-red-600 text-sm"
                  />
                </div>

                <!-- max. tenta. -->
                <div>
                  <label class="block mb-2 text-sm font-semibold text-gray-700"
                    >Tentativas máximas</label
                  >
                  <input
                    v-model.number="store.state.form.max_attempts"
                    type="number"
                    name="max_attempts"
                    min="1"
                    step="1"
                    class="w-full px-4 py-2 text-sm text-gray-800 placeholder-gray-400 bg-white border border-gray-300 rounded-xl shadow-sm focus:outline-none"
                  />
                  <span name="form.max_attempts" class="text-red-600 text-sm" />
                </div>
              </div>

              <!-- selecionar questão -->
              <div class="md:col-span-1">
                <div class="grid gap-4 gap-y-2 text-sm grid-cols-5">
                  <div class="col-span-4">
                    <label
                      class="block mb-2 text-sm font-semibold text-gray-700"
                      for="form.questionSelected"
                    >
                      Selecionar questão
                    </label>
                    <div class="h-10 flex rounded items-center">
                      <SimpleSelect
                        class="px-1 py-2 text-center uppercase appearance-none outline-none text-gray-800 w-full bg-transparent"
                        :key="clearOnSelected"
                        :data="questions"
                        :disable-keyboard="false"
                        @selected-data="
                          (val) => (addAnswerOptions(val))
                        "
                      />
                    </div>
                    <span
                      name="form.questionSelected"
                      class="text-red-600 text-sm"
                    />
                  </div>

                  <!-- Botão de Adicionar -->
                  <div class="col-span-1">
                    <div class="h-full">
                      <button
                        title="Cadastrar questão"
                        class="px-2 py-2 bg-gradient-to-r to-[#93cd24] from-[#0c7036] mt-3 text-white rounded-full hover:cursor-pointer transition-all hover:scale-105 text-center flex justify-center"
                        @click="questionModalOpen = !questionModalOpen"
                      >
                        <component class="w-8 h-8" :is="PhListPlus"></component>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="md:col-span-5" v-if="optionsAnswer?.length">
                <div class="mt-1 w-full max-h-[20vh] overflow-auto">
                  <h3
                    class="uppercase text-lg font-semibold text-start sticky top-0 bg-white p-1"
                  >
                    Questões: {{ optionsAnswer?.length }}
                  </h3>

                  <ul class="flex flex-wrap" v-if="optionsAnswer">
                    <li
                      v-for="(question, index) in optionsAnswer"
                      :key="index"
                      class="flex justify-between bg-gray-100 p-2 rounded-md m-1"
                    >
                      <label>
                        <!-- opção -->
                        <label class="font-bold uppercase">
                          <!-- Alternativa da pergunta -->
                          {{
                            question.name?.length > 20
                              ? question.name.slice(0, 20).concat("...")
                              : question.name
                          }}
                          <br />
                        </label>

                      </label>

                      <!-- remover -->
                      <button
                        @click="removeQuestion(question.value)"
                        class="text-red-500 hover:text-red-700 flex px-1"
                      >
                        <component
                          :is="PhX"
                          class="w-5 h-5 rounded-full bg-white p-0.5"
                        ></component>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- Botão de Salvar -->
              <div class="text-right flex justify-center md:justify-end">
                <slot />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import CleanInputButton from '../utils/CleanInputButton.vue'
import BaseInput from '@/components/Inputs/BaseInput.vue'
// import BlogEditor from "@/components/BlogEditor.vue";
import { sectorPriority } from '../lookups/form'
import { PhListPlus, PhX } from '@phosphor-icons/vue'
import { showToast as toast } from '@/helpers/UseToasts'
import { markRaw, computed, defineProps, ref } from 'vue'
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import { dataExtinguisher } from '../store'

import ModalQuestions from './_partials/ModalQuestions.vue'
import ExtinguisherService from '../service/extinguisher.service'
import { storeApp } from '@/store'

const props = defineProps({
  descriptionTitle: String,
  create: Boolean
})

const store = dataExtinguisher
const trainings = computed(() => dataExtinguisher.getters.getTrainingCollect)
const questions = computed(() => dataExtinguisher.getters.getQuestionCollect)
const optionsAnswer = computed(() => dataExtinguisher.getters.getAnswerOptionsCollect)
const questionModalOpen = ref(false) // modal de pergunta
const clearOnSelected = ref(0)
const appStore = storeApp.state

function close () {
  questionModalOpen.value = false
}

function addAnswerOptions (payload) {
  dataExtinguisher.commit('ADD_QUESTIONS_ANSWER', payload)
  clearOnSelected.value++
}

// remover questão
function removeQuestion (qId) {
  if (store.state.form.answerOptionsCollect) {
    store.state.form.answerOptionsCollect.splice({ value: qId }, 1)

    if (props.create !== true) {
      Promise.allSettled([
        ExtinguisherService.removeQuestionAssessment(qId, store.state.form?.id)
          .catch((err) => {
            if (
              err?.response?.data?.error &&
              err.response.data.status === 400
            ) {
              return toast('Aviso', err.response.data.message, 'error')
            }

            if (
              err?.response?.data?.error &&
              err.response.data.status === 404
            ) {
              return toast('Aviso', err.response.data.message, 'error')
            }

            return toast(
              'Aviso',
              'Algo deu errado ao remover questão',
              'error'
            )
          })
      ])
    }
  }
}

// cadastrar nova questão
async function registerQuestion () {
  appStore.loading = true

  Promise.allSettled([
    ExtinguisherService.createQuestion(store.state.question)
      .then(res => {
        toast(
          'Aviso',
          'Pergunta cadastrada com sucesso',
          'success'
        )

        dataExtinguisher.dispatch('getComboQuestion')
        appStore.loading = false
      }).catch(err => {
        appStore.loading = false

        toast(
          'Aviso',
          'Pergunta cadastrada com sucesso',
          'success'
        )

        console.log(err)
      })
  ])
}

</script>
